import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_3 = { class: "card-body pt-9 pb-0" }
const _hoisted_4 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/avatars/admin.png",
      alt: "image"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" })
  ])
], -1)
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_11 = { href: "#" }
const _hoisted_12 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_13 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_14 = { class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-outline btn-outline-warning btn-active-light-warning me-2 mb-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_ubah_sandi"
}, " Ubah Kata Sandi ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-4" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap" })
  ])
], -1)
const _hoisted_18 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_ubah_sandi",
  ref: "ubahSandiModalRef"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_20 = { class: "modal-content rounded" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title mb-6" }, " Ubah Kata Sandi "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_22 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col mb-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Kata Sandi Lama Anda", -1)
const _hoisted_26 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col mb-8" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Kata Sandi Baru Anda", -1)
const _hoisted_32 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Konfirmasi Kata Sandi Baru Anda", -1)
const _hoisted_38 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "modal-footer" }
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.name), 1),
                  _createElementVNode("a", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.email), 1)
                ]),
                _hoisted_15
              ]),
              _hoisted_16
            ]),
            _hoisted_17
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Field, {
                  type: "password",
                  name: "oldPassword",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Kata Sandi Lama Anda",
                  modelValue: _ctx.items.oldPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.items.oldPassword) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.items.oldPassword == '' )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.items.erroroldPassword), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28))
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_Field, {
                  type: "password",
                  name: "newPassword",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Kata Sandi Baru Anda",
                  modelValue: _ctx.items.newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.items.newPassword) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.items.newPassword == '' )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.items.errornewPassword), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34))
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_Field, {
                  type: "password",
                  name: "confirmNewPassword",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Konfirmasi Kata Sandi Baru Anda",
                  modelValue: _ctx.items.confirmNewPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.items.confirmNewPassword) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmed()))
                }, null, 8, ["modelValue"]),
                (_ctx.items.confirmNewPassword != '' )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.items.errorconfirmNewPassword), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.items.errorconfirmNewPassword), 1)
                    ]))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-light",
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batalUbahSandi()))
            }, " Batal "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitAdd())),
              disabled: _ctx.items.disableButton
            }, " Simpan ", 8, _hoisted_43)
          ])
        ])
      ])
    ], 512)
  ], 64))
}